[
  {
    "inputs": [
      { "internalType": "address", "name": "admin_", "type": "address" },
      { "internalType": "address", "name": "coinDepoToken_", "type": "address" },
      { "internalType": "uint256", "name": "phaseOneTotalX18_", "type": "uint256" },
      { "internalType": "uint256", "name": "phaseOneDuration_", "type": "uint256" },
      { "internalType": "uint256", "name": "phaseTwoTotalWindows_", "type": "uint256" },
      { "internalType": "uint256", "name": "phaseTwoWindowX18_", "type": "uint256" }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  { "inputs": [], "name": "AccessControlBadConfirmation", "type": "error" },
  {
    "inputs": [
      { "internalType": "address", "name": "account", "type": "address" },
      { "internalType": "bytes32", "name": "neededRole", "type": "bytes32" }
    ],
    "name": "AccessControlUnauthorizedAccount",
    "type": "error"
  },
  { "inputs": [], "name": "AlreadyStarted", "type": "error" },
  { "inputs": [], "name": "CustodyPartAlreadyExists", "type": "error" },
  { "inputs": [], "name": "HasNoVesting", "type": "error" },
  { "inputs": [], "name": "InvalidAddress", "type": "error" },
  { "inputs": [], "name": "InvalidAmount", "type": "error" },
  {
    "inputs": [
      { "internalType": "uint256", "name": "usersLength", "type": "uint256" },
      { "internalType": "uint256", "name": "amountLength", "type": "uint256" }
    ],
    "name": "InvalidBatchInput",
    "type": "error"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "phaseOneTotalX18", "type": "uint256" },
      { "internalType": "uint256", "name": "phaseOneDuration", "type": "uint256" },
      { "internalType": "uint256", "name": "phaseTwoTotalWindows", "type": "uint256" },
      { "internalType": "uint256", "name": "phaseTwoWindowX18", "type": "uint256" }
    ],
    "name": "InvalidPhasesConfiguration",
    "type": "error"
  },
  { "inputs": [], "name": "InvalidStartTimestamp", "type": "error" },
  { "inputs": [], "name": "NoDistribution", "type": "error" },
  { "inputs": [], "name": "NotStarted", "type": "error" },
  {
    "inputs": [
      { "internalType": "address", "name": "user", "type": "address" },
      {
        "components": [
          { "internalType": "uint256", "name": "amount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneTotalAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneDaily", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseTwoWindowAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "withdrawn", "type": "uint256" }
        ],
        "internalType": "struct ICoindepoSaleDistribution.VestingData",
        "name": "vestingData",
        "type": "tuple"
      }
    ],
    "name": "VestingDataAlreadyExists",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [{ "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }],
    "name": "CustodyPartClaimed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          { "internalType": "address", "name": "beneficiary", "type": "address" },
          { "internalType": "uint256", "name": "amount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneTotalAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneDaily", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseTwoWindowAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "withdrawn", "type": "uint256" }
        ],
        "indexed": false,
        "internalType": "struct ICoindepoSaleDistribution.CustodyPart",
        "name": "custodyPart",
        "type": "tuple"
      }
    ],
    "name": "CustodyPartCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" },
      { "indexed": true, "internalType": "bytes32", "name": "previousAdminRole", "type": "bytes32" },
      { "indexed": true, "internalType": "bytes32", "name": "newAdminRole", "type": "bytes32" }
    ],
    "name": "RoleAdminChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" },
      { "indexed": true, "internalType": "address", "name": "account", "type": "address" },
      { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }
    ],
    "name": "RoleGranted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" },
      { "indexed": true, "internalType": "address", "name": "account", "type": "address" },
      { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }
    ],
    "name": "RoleRevoked",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "user", "type": "address" },
      { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "VestingClaimed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "user", "type": "address" },
      {
        "components": [
          { "internalType": "uint256", "name": "amount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneTotalAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneDaily", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseTwoWindowAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "withdrawn", "type": "uint256" }
        ],
        "indexed": false,
        "internalType": "struct ICoindepoSaleDistribution.VestingData",
        "name": "vestingData",
        "type": "tuple"
      }
    ],
    "name": "VestingDataCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": false, "internalType": "uint256", "name": "totalLockAmount", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "startedAt", "type": "uint256" }
    ],
    "name": "VestingStarted",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "ADMIN_ROLE",
    "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "DEFAULT_ADMIN_ROLE",
    "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "ONE_DAY",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "ONE_MONTH",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address[]", "name": "users", "type": "address[]" },
      { "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }
    ],
    "name": "batchCreateVestingData",
    "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claimCustodyPart",
    "outputs": [{ "internalType": "uint256", "name": "claimAmount", "type": "uint256" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claimVesting",
    "outputs": [{ "internalType": "uint256", "name": "claimAmount", "type": "uint256" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "coinDepoToken",
    "outputs": [{ "internalType": "contract IERC20", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "beneficiary", "type": "address" },
      { "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "createCustodyPart",
    "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "user", "type": "address" },
      { "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "createVestingData",
    "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getAvailableCustodyPartClaimAmount",
    "outputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "address", "name": "user", "type": "address" }],
    "name": "getAvailableUserClaimAmount",
    "outputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getCustodyPart",
    "outputs": [
      {
        "components": [
          { "internalType": "address", "name": "beneficiary", "type": "address" },
          { "internalType": "uint256", "name": "amount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneTotalAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneDaily", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseTwoWindowAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "withdrawn", "type": "uint256" }
        ],
        "internalType": "struct ICoindepoSaleDistribution.CustodyPart",
        "name": "custodyPart",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "bytes32", "name": "role", "type": "bytes32" }],
    "name": "getRoleAdmin",
    "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "address", "name": "user", "type": "address" }],
    "name": "getVestingDataByUser",
    "outputs": [
      {
        "components": [
          { "internalType": "uint256", "name": "amount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneTotalAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseOneDaily", "type": "uint256" },
          { "internalType": "uint256", "name": "phaseTwoWindowAmount", "type": "uint256" },
          { "internalType": "uint256", "name": "withdrawn", "type": "uint256" }
        ],
        "internalType": "struct ICoindepoSaleDistribution.VestingData",
        "name": "vestingData",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "bytes32", "name": "role", "type": "bytes32" },
      { "internalType": "address", "name": "account", "type": "address" }
    ],
    "name": "grantRole",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "bytes32", "name": "role", "type": "bytes32" },
      { "internalType": "address", "name": "account", "type": "address" }
    ],
    "name": "hasRole",
    "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "phaseOneDuration",
    "outputs": [{ "internalType": "uint256", "name": "duration", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "phaseOneTotalX18",
    "outputs": [{ "internalType": "uint256", "name": "phaseOneShareX18", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "phaseTwoDuration",
    "outputs": [{ "internalType": "uint256", "name": "duration", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "phaseTwoTotalWindows",
    "outputs": [{ "internalType": "uint256", "name": "countOfWindows", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "phaseTwoWindowX18",
    "outputs": [{ "internalType": "uint256", "name": "windowShareX18", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "bytes32", "name": "role", "type": "bytes32" },
      { "internalType": "address", "name": "callerConfirmation", "type": "address" }
    ],
    "name": "renounceRole",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "bytes32", "name": "role", "type": "bytes32" },
      { "internalType": "address", "name": "account", "type": "address" }
    ],
    "name": "revokeRole",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint256", "name": "startTimestamp", "type": "uint256" }],
    "name": "start",
    "outputs": [{ "internalType": "uint256", "name": "startedAt_", "type": "uint256" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "started",
    "outputs": [{ "internalType": "bool", "name": "status", "type": "bool" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "startedAt",
    "outputs": [{ "internalType": "uint256", "name": "timestamp", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "bytes4", "name": "interfaceId", "type": "bytes4" }],
    "name": "supportsInterface",
    "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalLockAmount",
    "outputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  }
]